const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const staffDetailsFormData = [
  {
    id: "name",
    label: "Name :",
    placeHolder: "Enter name",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "aka_name",
    label: "AKA Name :",
    tooltipText: "AKA Name",
    placeHolder: "Enter AKA Name",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "staff_email",
    label: "Email :",
    placeHolder: "Enter email",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "phone",
    label: "Phone :",
    placeHolder: "Enter phone",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "driver_licence",
    label: "Driver Licence :",
    placeHolder: "Enter driver licence",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "licence_expiry_date",
    label: "Expires :",
    placeHolder: "Enter expiry date",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id:'is_deleted',
    label: "Status :",
    placeHolder: "Enter status",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "address",
    label: "Address ",
    placeHolder: "Enter address",
    type: "viewField",
    md: 12,
    isFlexField: true,
  },
];
export const STAFF_SECOND_PART_DETAILS = [
  {
    id: "ni_number",
    label: "NI Number :",
    placeHolder: "Enter NI Number",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "checked_date",
    label: "Checked Date :",
    tooltipText: "Checked Date",
    placeHolder: "Enter Checked Date",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "checked_by",
    label: "Checked By :",
    placeHolder: "Enter Checked By",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "sort_order",
    label: "Sort Order :",
    placeHolder: "Enter sort order",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "contract_type",
    label: "Contract Type :",
    placeHolder: "Enter contract type",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "wage_rate",
    label: "Wage Rate :",
    placeHolder: "Enter wage rate",
    type: "viewField",
    prefixIcon: "£",
    md: 6,
    isFlexField: true,
  },
  {
    id: "overtime_rate",
    label: "Overtime Rate :",
    placeHolder: "Enter overtime rate",
    type: "viewField",
    prefixIcon: "£",
    md: 6,
    isFlexField: true,
  },

  {
    id: "emergency_contact_name",
    label: "Emergency Contact Name :",
    placeHolder: "Enter emergency contact name",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "emergency_contact_relation",
    label: "Emergency Contact Relation :",
    placeHolder: "Enter emergency contact relation",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "emergency_contact_number",
    label: "Emergency Contact Number :",
    placeHolder: "Enter emergency contact number",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "notes",
    label: "Notes ",
    placeHolder: "Enter notes",
    type: "viewField",
    md: 12,
    isFlexField: true,
  },
];

export const STAFF_FORM_FIELDS = [
  {
    id: "name",
    label: "Staff Name :",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
  {
    id: "aka_name",
    label: "AKA Name :",
    placeHolder: "",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },

  {
    id: "phone",
    label: "Phone :",
    placeholder: "",
    type: "contact",
    width: "80px",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 4,
  },
  {
    id: "staff_email",
    label: "Email :",
    placeholder: "",
    type: "text",
    width: "80px",
    // isRequired: true,
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },

  {
    id: "address",
    label: "Address :",
    placeholder: "",
    type: "textarea",
    // width: "80px",
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
  {
    id: "driver_licence",
    label: "Driver Licence :",
    placeholder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 16,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },
  {
    id: "licence_expiry_date",
    label: "Licence Expiry Date :",
    placeholder: "",
    type: "date",
    md: 4,
  },
  {
    id: "ni_number",
    label: "NI Number :",
    placeholder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 10,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },

  {
    id: "checked_date",
    label: "Checked Date :",
    placeholder: "",
    type: "date",
    md: 4,
  },
  {
    id: "checked_by",
    label: "Checked By :",
    placeholder: "",
    type: "select",
    options: [],
    inputProps: {
      maxLength: 12,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },
  {
    id: "sort_order",
    label: "Sort Order :",
    placeholder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 4,
  },
  {
    id: "skills",
    label: "Skills :",
    placeHolder: "",
    type: "multiSelectChip",
    options: [],
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
  {
    id: "contract_type",
    label: "Contract Type :",
    placeHolder: "",
    type: "select",
    options: ["Paye", "Full Time", "Part Time", "Casual", "Subcontractor"],
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },
  {
    id: "wage_rate",
    label: "Wage Rate :",
    placeholder: "",
    type: "text",
    prefixIcon: "£",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 4,
  },
  {
    id: "overtime_rate",
    label: "Overtime Rate :",
    placeholder: "",
    type: "text",
    prefixIcon: "£",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 4,
  },
  {
    id: "emergency_contact_name",
    label: "Emergency Contact Name :",
    placeholder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },
  {
    id: "emergency_contact_relation",
    label: "Emergency Contact Relation :",
    placeholder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
  },
  {
    id: "emergency_contact_number",
    label: "Emergency Contact Number :",
    placeholder: "",
    type: "contact",
    width: "80px",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 4,
  },
  {
    id: "notes",
    label: "Notes :",
    placeHolder: "",
    type: "textarea",
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
];

export const STAFF_ABSENCE_FORM_FIELDS = [
  {
    id: "reason",
    label: "Reason :",
    placeHolder: "",
    type: "select",
    options: ["Holiday", "Sickness", "Others"],
    inputProps: {
      maxLength: 150,
    },
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },

  {
    id: "start_date",
    label: "Start Date :",
    placeholder: "",
    type: "date",
    isRequired: true,
    md: 6,
  },

  {
    id: "end_date",
    label: "End Date :",
    placeholder: "",
    type: "date",
    md: 6,
  },
  {
    id: "notified_date",
    label: "Notified Date :",
    placeholder: "",
    type: "date",
    md: 6,
  },

  {
    id: "authorised_date",
    label: "Authorised Date :",
    placeholder: "",
    type: "date",
    md: 6,
  },

  {
    id: "authorised_by",
    label: "Authorised By :",
    placeholder: "",
    type: "select",
    options: [],

    md: 12,
  },
];

export const STAFF_FILTERS = [
  {
    id: "skill",
    label: "Skill",
    type: "select",
    options: [],
    placeHolder: "All Skill",
    md: 7,
    isFlexField: false,
  },
  {
    id: "is_deleted",
    label: "Status",
    type: "select",
    options: ["Active", "Deleted"],
    placeHolder: "All",
    md: 5,
    isFlexField: false,
  },
];
